import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { Observable } from "rxjs";

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {
    constructor(private readonly oauthService: OAuthService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.oauthService.hasValidIdToken() && this.oauthService.hasValidAccessToken() && (this.oauthService.getAccessToken() ?? '') != '') {
            const modifiedRequest = req.clone({ headers: req.headers.set('Authorization', `Bearer ${this.oauthService.getAccessToken()}`)});
            return next.handle(modifiedRequest);
        } else {
            return next.handle(req);
        }
    }
}
